import { z } from "zod";
import { ISSUE_GROUPS } from "../../../shared/schemas/issues";

/**
 * A filter page's address (BUILD_SPEC §12.9): the query as edited, until it is saved; the issue in its peek; and its
 * grouping. Its own module, as the routes' address rules load with the app, before any page's code.
 */
export const filterSearchSchema = z.object({
  jql: z.string().max(10_000).optional().catch(undefined),
  issue: z.string().min(1).optional().catch(undefined),
  group: z.enum(ISSUE_GROUPS).optional().catch(undefined),
});
export type FilterSearch = z.infer<typeof filterSearchSchema>;
